import { Injectable, Signal } from '@angular/core';

import { ThemeMode, ThemeModeProvider } from '@campaign-portal/contracts/theme';
import { ThemeModeService } from '../services';

@Injectable({ providedIn: 'root' })
export class ThemeModeAdapter extends ThemeModeProvider {
	readonly mode: Signal<ThemeMode>;

	constructor(private readonly source: ThemeModeService) {
		super();
		this.mode = this.source.mode;
	}

	setMode(mode: ThemeMode): void {
		this.source.setMode(mode);
	}
}
